import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SensorFeaturesList from './SensorFeaturesList';
import {
    getVisibleFeatures,
} from '../helpers';

const SensorFeaturesComponent = (props) => {
    const { t: translate } = useTranslation();
    const [show, setshow] = useState(false);
    const sensorFeatures = props.sensorFeatures;
    const firmwareUpdate = props.firmwareUpdate;
    const timeseriesInfo = props.sensorTimeseriesInfo;
    const sensorRssiValue = props.sensorRssiValue;
    const sensorBatteryLevel = props.sensorBatteryLevel;
    const isFirmwareUpdateEnforced = firmwareUpdate?.updateAvailable &&
        firmwareUpdate?.updateEnforced;
    const visibleFeatures = getVisibleFeatures(sensorFeatures);

    return <>
        {!!visibleFeatures.length &&
            <div className='sensor-properties-list' >
                <div className='sensor-properties-list-title'>{translate('ABB.Powertrain.Frontend.sensorFeatures')}</div>
                <SensorFeaturesList
                    visibleFeatures={visibleFeatures} timeseriesInfo={timeseriesInfo} sensorRssiValue={sensorRssiValue} show={show} setshow={setshow} isFirmwareUpdateEnforced={isFirmwareUpdateEnforced} sensorBatteryLevel={sensorBatteryLevel} />
            </div>}
    </>;
};

export default SensorFeaturesComponent;

SensorFeaturesComponent.propTypes = {
    model: PropTypes.shape({
        firmwareID: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        gatewayInfo: PropTypes.object,
        sensorProperties: PropTypes.object,
        sensorFeatures: PropTypes.array,
    }),
    firmwareUpdate: PropTypes.object
};
